import PartnerDomainsForm from "./PartnerDomainsForm";

export default PartnerDomainsForm;


// WEBPACK FOOTER //
// ./src/scenes/PartnerDomains/components/PartnerDomainsForm/index.js